import { render, staticRenderFns } from "./GdprDialog.vue?vue&type=template&id=e5c0e2f8&"
import script from "./GdprDialog.vue?vue&type=script&lang=js&"
export * from "./GdprDialog.vue?vue&type=script&lang=js&"
import style0 from "./GdprDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports